import type { ComicEpisode, ComicProject } from './comicTypes'

/**
 * 保存后合并服务端响应与本地编辑态：保留本地 pages/panels 顺序与未落库字段，
 * 同时吸收服务端权威 id、时间戳与空 pages 回填。
 */
export function mergeComicProjectAfterSave(next: ComicProject, saved: ComicProject): ComicProject {
  const savedEpById = new Map(saved.episodes.map((ep) => [ep.id, ep]))
  const mergeEpisode = (localEp: ComicEpisode) => {
    const savedEp = savedEpById.get(localEp.id)
    if (!savedEp) return localEp
    const savedPanelById = new Map(savedEp.panels.map((p) => [p.id, p]))
    return {
      ...localEp,
      panels: localEp.panels.map((p) => savedPanelById.get(p.id) ?? p),
      pages: localEp.pages.length > 0 ? localEp.pages : savedEp.pages,
    }
  }
  const mergedEpisodes = next.episodes.map(mergeEpisode)
  for (const savedEp of saved.episodes) {
    if (mergedEpisodes.some((e) => e.id === savedEp.id)) continue
    // 并发保存可能产生同 index、不同 id 的话次；以本地为准，避免合并出重复话次
    if (mergedEpisodes.some((e) => e.index === savedEp.index)) continue
    mergedEpisodes.push(savedEp)
  }
  mergedEpisodes.sort((a, b) => a.index - b.index)
  return {
    ...saved,
    creative: next.creative,
    settings: next.settings,
    episodes: mergedEpisodes,
    episodeCount: mergedEpisodes.length,
  }
}
